export default {
  name: 'uploadImageWindow',
  data () {
    return {
      ComponentName: 'uploadImageWindow',
      file: null,
      imgBase64: null,
      status: false,
    };
  },
  methods: {
    addFile (e) {
      this.file = e.target.files[0];
      this.toBase64();
    },
    closeForm () {
      this.status = false;
    },
    toBase64 () {
      var reader = new FileReader();
      reader.addEventListener('load', (res) => {
        this.imgBase64 = res.srcElement.result;
      }, false);
      reader.readAsDataURL(this.file);
    },
    submitFile (e) {
      e.preventDefault();
      if (this.imgBase64 != null) {
        this.$emit('uploadImg', this.imgBase64);
        this.closeForm();
      } else {
        alert('file is not upload');
      }
    },
    removeFile () {
      this.file = null;
      this.imgBase64 = null;
    },
  },
  watch: {
    status (val) {
      if (!val) {
        return;
      };
      var DOMwatcher = () => {
        var DOMisRender = this.$el.__proto__.constructor.name == 'HTMLDivElement';
        setTimeout(() => {
          if (!DOMisRender) {
            DOMwatcher();
          } else {
            const preventDefaults = (e) => {
              e.preventDefault();
              e.stopPropagation();
            };
            const area = this.$el.getElementsByClassName('dd-area')[0];
            ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {
              area.addEventListener(eventName, preventDefaults, false);
            });
            area.addEventListener('dragenter', (e) => {
              area.classList.add('dragenter');
            });
            area.addEventListener('dragleave', () => {
              area.classList.remove('dragenter');
            });
            area.addEventListener('drop', (e) => {
              const dt = e.dataTransfer;
              this.file = dt.files[0];
              this.toBase64();
              e.preventDefault();
            });
          }
        }, 100);
      };
      DOMwatcher();
    },
  },
  mounted () {
    this.$on('show-window', () => {
      this.status = true;
    });
  },
};
